import "./style.scss";

const ButtonSelector = ({items, selected, onSelect=null}) => {
  return <div className="buttonSelector disable-select">
    {
      items.map((item, i) => {
        return <div key={i} className={i === selected ? "button selected" : "button"} onClick={() => onSelect(i)}>
          {item}
        </div>
      })
    }
  </div>
}

export default ButtonSelector;